import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group, GroupMembershipRequested } from "@shared/models/group"
import type NotifierService from "cc-frontend/services/notifier"
import type Rpc from "cc-frontend/services/rpc"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    row: GroupMembershipRequested
    group: Group
  }
}

export default class GroupMembersTableActionsApproveRequestCell extends Component<Signature> {
  @service declare rpc: Rpc
  @service declare notifier: NotifierService

  @tracked isExecutingRpc = false

  @action
  approveRequest() {
    this.isExecutingRpc = true

    const email = this.args.row.attributes.cachedUserEmail
    this.rpc
      .group_approve_membership_request({
        groupId: this.args.group.id,
        membershipId: this.args.row.id,
      })
      .then((response) => {
        if (response.responseOk === true) {
          this.notifier.success("", {
            title: `${email} was added!`,
            message: "We're sending them an email right now.",
            duration: 3000,
          })
        }

        if (this.isDestroyed || this.isDestroying) {
          return
        } else {
          this.isExecutingRpc = false
        }
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Cells::ActionsApproveRequest": typeof GroupMembersTableActionsApproveRequestCell
  }
}
